import { Heading } from '@big-red-group/storefront-common-ui'
import Icon from './Icons'
import Container from './Container'
import { Content, Location, Wrapper, GraphicWrapper } from './HomeMemberHero.styles'

const HomeMemberHero: React.FC<{ image: string; title: string; location: string }> = ({ image, title, location }) => {
  return (
    <Container dataMcpId="destination-promo" spacing="XXXS" style={{ position: 'relative' }}>
      <Wrapper image={image} data-testid="home-member-image">
        <Content>
          <Heading size="XL" dataTestId="home-member-title" balanced>
            {title}
          </Heading>
          {/* <Button onClick={() => {}} size="L">
          Get member pricing
        </Button> */}
        </Content>
        <Location data-testid="home-member-location">
          <svg
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ marginRight: '4px' }}
          >
            <path
              d="M7.5 0.9375C4.78125 0.9375 1.875 3 1.875 6.5625C1.875 10.0312 7.5 15 7.5 15C7.5 15 13.125 10.0312 13.125 6.5625C13.125 3 10.2188 0.9375 7.5 0.9375ZM7.5 8.4375C6.46875 8.4375 5.625 7.59375 5.625 6.5625C5.625 5.53125 6.46875 4.6875 7.5 4.6875C8.53125 4.6875 9.375 5.53125 9.375 6.5625C9.375 7.59375 8.53125 8.4375 7.5 8.4375Z"
              fill="white"
            />
          </svg>
          {location}
        </Location>
      </Wrapper>
      <GraphicWrapper>
        <Icon name="australiaOutline" />
      </GraphicWrapper>
    </Container>
  )
}

export default HomeMemberHero
